class Utils {
  constructor(client) {
    this.client = client;
  }

  importExcelDocument(payload) {
    return this.client.post('/file/excel', payload);
  }
}

export default Utils;
